import { get } from './object-helpers';
import { getGlobals } from './global-variables';

export const tabNames = {
    SHOP: 'shop',
    SALES: 'sales',
    ABOUT: 'about'
};

const tabMapping = {
    [tabNames.SHOP]: 'shopTabIndexes',
    [tabNames.SALES]: 'salesTabIndexes',
    [tabNames.ABOUT]: 'aboutTabIndexes'
};

function getTabIndexFromHash(provided) {
    const hash = provided || document.location.hash;
    if (hash?.indexOf('#tab') === 0) {
        const foundTabIndex = parseInt(
            // Get the tab index only
            hash.replace('#tab', '')
        );
        const localUrl = buildUpdatedUrl(foundTabIndex);
        window.history.replaceState('', '', localUrl.pathname + localUrl.search);
        return foundTabIndex;
    }
    return undefined;
}

function buildUpdatedUrl(selectedIndex) {
    const localUrl = new URL(document.location.href);
    if (selectedIndex > 0) {
        localUrl.searchParams.set('_tab', selectedIndex);
    } else {
        localUrl.searchParams.delete('_tab');
    }
    return localUrl;
}

export function getRequestedTabFromUrl(url) {
    const localUrl = new URL(url);
    const tabQueryParam = localUrl.searchParams.get('_tab');
    return !!tabQueryParam ? +tabQueryParam : getTabIndexFromHash(localUrl.hash) || 0;
}

export function getRequestedTab(out) {
    if (typeof document === 'undefined') {
        return +get(out, 'attributes.req.query._tab', 0);
    }
    const tabQueryParam = new URL(document.location.href).searchParams.get('_tab');
    return !!tabQueryParam ? +tabQueryParam : getTabIndexFromHash() || 0;
}

export function setTabUrlParam(selectedIndex) {
    const localUrl = buildUpdatedUrl(selectedIndex);
    window.history.pushState('', '', localUrl.href);
}

export function getTabMapping(tabName) {
    const globals = getGlobals();
    const globalLocation = tabMapping[tabName];
    return !globalLocation ? [] : globals[tabMapping[tabName]] || [];
}

export function isTab(tabName, idx) {
    return getTabMapping(tabName).indexOf(`tab${idx}`) !== -1;
}

export function getTabIdx(tabName) {
    const tabIdx = getTabMapping(tabName)[0]?.replace('tab', '');
    return tabIdx ? +tabIdx : null;
}
